import {SocialAuthIntegration} from '@practicegenius/domain/src/data/integrations';

export const platformLabels: {
  [k in SocialAuthIntegration]: string;
} = {
  facebook: 'Facebook',
  google: 'Google',
  apple: 'Apple',
};
